import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { Observable } from 'rxjs';
import {
  InspectionData,
  InspectionReportUrl,
} from '../../models/inspection.model';
import { InspectionReportVersionsReadUrlsResponse } from '../interfaces/InspectionVersion';
import { InspectionDataResponse } from '../../models/inspection.model';

@Injectable({
  providedIn: 'root'
})
export class InspectionsService {

  constructor(
    private httpService: HttpService
  ) {
  }

  createInspectionFromOrders(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.INSPECTIONS.BASE, data);
  }

  createInspectionFromFile(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.INSPECTIONS.IMPORT_FILE, data);
  }

  getInspections(query: Record<string, any>): Observable<{
    data: InspectionData[],
    total: number,
    totalPendingClientDecision: number
  }> {
    return this.httpService.getData(APIS.INSPECTIONS.BASE, { ...query, context: 'planningApp' });
  }

  updateClientDecision(clientDecisionId: string, inspId: string): Observable<any> {
    return this.httpService.putData(
      APIS.INSPECTIONS.UPDATE.replace(':id', inspId),
      { clientDecisionId }
    );
  }

  getReportVersions(inspId: string): Observable<any> {
    return this.httpService.getData(APIS.INSPECTIONS.REPORT_VERSIONS.replace(':id', inspId));
  }

  postInspectionReportVersionsReadUrls(
    inspId: string,
    historyIds: string[],
  ): Observable<InspectionReportVersionsReadUrlsResponse> {
    const path = APIS.INSPECTIONS.REPORT_VERSIONS_READ_URLS.replace(':id', inspId);
    return this.httpService.postData(path, { historyIds });
  }

  getInspectionReportPdf(
    inspId: string,
    mintType?: 'full' | 'summary' | 'both',
  ): Observable<InspectionReportUrl> {

    const path = APIS.INSPECTIONS.PDF_REPORT.replace(':id', inspId);


    const query = mintType && mintType !== 'both'


      ? { type: mintType }


      : undefined;


    return this.httpService.getData(path, query);


  }

  shareInspectionReport(
    inspId: string,
    payload: { toAddresses: string[]; message?: string }
  ): Observable<{ message: string }> {
    const path = APIS.INSPECTIONS.SHARE_REPORT.replace(':id', inspId);
    return this.httpService.postData(path, payload);
  }

  update(id: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.INSPECTIONS.BASE}/${id}`, data);
  }

  sync(id: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.INSPECTIONS.SYNC}/${id}`, data);
  }

  delete(id: string): Observable<any> {
    return this.httpService.deleteData(`${APIS.INSPECTIONS.BASE}/${id}`);
  }

  getInspectionDetail(id: string): Observable<InspectionDataResponse> {
    return this.httpService.getData(`${APIS.INSPECTIONS.BASE}/${id}`);
  }

  getCustomersForFilter(): Observable<Array<{ id: string; code: string; name: string }>> {
    return this.httpService.getDataWithCache(APIS.INSPECTIONS.CUSTOMERS);
  }

}
